import React from 'react';
import type { CustomerState } from '../../customer-states/types/customer-states.types';

interface CustomerStateBadgeProps {
    state?: CustomerState | null;
    className?: string;
    onClick?: () => void;
    compact?: boolean;
}

export const CustomerStateBadge: React.FC<CustomerStateBadgeProps> = ({
    state,
    className = '',
    onClick,
    compact = false
}) => {
    if (!state) return null;

    const getStateColor = (type?: string): string => {
        switch (type) {
            case 'INITIAL': return '#00a884';
            case 'FINAL': return '#ef5350';
            case 'TRANSIENT': return '#ff9800';
            default: return '#667781';
        }
    };

    const color = getStateColor(state.type);

    if (compact) {
        return (
            <span
                className={`badge align-middle ${onClick ? 'cursor-pointer' : ''} ${className}`}
                style={{
                    backgroundColor: `${color}15`,
                    color: color,
                    border: `1px solid ${color}30`,
                    fontSize: '10px',
                    fontWeight: '500',
                    padding: '2px 6px',
                    transition: 'all 0.2s ease'
                }}
                onClick={onClick}
            >
                {state.name}
            </span>
        );
    }

    return (
        <span
            className={`badge align-middle ${onClick ? 'cursor-pointer' : ''} ${className}`}
            style={{
                backgroundColor: `${color}15`,
                color: color,
                border: `1px solid ${color}30`,
                fontSize: '11px',
                fontWeight: '500',
                padding: '4px 8px',
                transition: 'all 0.2s ease'
            }}
            onClick={onClick}
        >
            <span
                className="d-inline-block rounded-circle me-1"
                style={{
                    width: '6px',
                    height: '6px',
                    backgroundColor: color
                }}
            />
            {state.name}
        </span>
    );
};
